export class Customer {
  id?: number;
  name: string;
  searchName: string;
  eveCustomFields: string[];

  constructor(object: any) {
    this.id = object.id;
    this.name = object.name;
    this.searchName = object.searchName;
    this.eveCustomFields = object.eveCustomFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/models/customer.model.ts